import Vue from 'vue'
import axios from '@/wrappers/axios.js'

const TestResultService = {

    getList(params) {
        return axios.get(`/test-results${params}`)
            .then(response => {
                return Promise.resolve(response.data);
            });
    },

    update(id,data) {
        return axios.put(`/test-results/${id}`,data)
            .then(response => {
                return Promise.resolve(response.data);
            });
    },

    getAsOptions(params) {
        return axios.get(`/test-results/options${params}`)
            .then(response => {
                return Promise.resolve(response.data);
            });
    },

    extractSteps(data){
        return axios.post(`/test-results/extract-steps`,data)
            .then(response => {
                return Promise.resolve(response.data);
            });
    },

    cloneSteps(id){
        return axios.post(`/test-results/${id}/clone-steps`)
            .then(response => {
                return Promise.resolve(response.data);
            });
    },
}

Vue.$testResultService = TestResultService

export default TestResultService